/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products
 *
 * Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'lib/@waca/core-client/js/core-client/ui/core/Class'
], function(BaseClass) {
	'use strict';
	return BaseClass.extend({
		render: function() {
			return Promise.resolve();
		}
	});
});
